import styled from "styled-components";
import theme from "./theme";

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  gap: ${theme.gap};
  max-width: 100%;
`;
